import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import GlobalStyle from './config/GlobalStyles'; // Importa GlobalStyle
import reportWebVitals from './reportWebVitals';
import { registerServiceWorker } from './services/serviceWorkerService';
import InstallAppBanner from './components/pwa/InstallAppBanner';
import OfflineBanner from './components/pwa/OfflineBanner';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <GlobalStyle /> {/* Añade GlobalStyle aquí */}
    <App />
    <OfflineBanner />
    <InstallAppBanner />
  </React.StrictMode>
);

reportWebVitals();

// App instalable en el celular: pantalla sin conexión y carga más rápida.
registerServiceWorker();